import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class PiggyMechanicType extends Cloneable {
    static ORDER = new PiggyMechanicType(0, "ORDER");
    static MERGE = new PiggyMechanicType(1, "MERGE");
    static ENERGY = new PiggyMechanicType(2, "ENERGY");

    static _values = [this.ORDER, this.MERGE, this.ENERGY];

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, PiggyMechanicType.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof PiggyMechanicType) {
            return PiggyMechanicType._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    constructor(id = 0, name = "UNKNOWN") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    equal(value) {
        if (value instanceof PiggyMechanicType) {
            return this.id === value.id;
        } else if (Number.isInteger(value)) {
            return this.id === value;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new PiggyMechanicType());
        } else if (target instanceof PiggyMechanicType) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(PiggyMechanicType, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});